<template>
  <a-tooltip
    :title="`Chatbot con configuración ${configuredTo}`"
    :overlayInnerStyle="{ textAlign: 'center' }"
  >
    <div class="pill">
      <img
        v-if="chatbot.type_bot === BotType.MonoChannel"
        class="icon"
        :src="currentChannel.icon"
        :alt="currentChannel.name"
      />

      <SocialIcon
        v-if="chatbot.type_bot === BotType.MultiChannel"
        class="icon"
        type="Multichannel"
      />
    </div>
  </a-tooltip>
</template>

<script setup>
import { computed } from "vue";

import { BotType } from "@/app/chatbots/utils/enums";

import SocialIcon from "@/app/channels/components/cards/SocialIcon.vue";

const props = defineProps({
  chatbot: { type: Object, default: () => ({}) },
  currentChannel: { type: Object, default: () => ({}) },
});

const configuredTo = computed(() => {
  if (props.chatbot.type_bot === BotType.MonoChannel) return `para ${props.currentChannel?.name}`;

  return "multicanal";
});
</script>

<style scoped lang="sass">
.pill
  width: 24px
  height: 24px
  display: flex
  justify-content: center
  align-items: center
  border: 0.5px solid $gray-4
  border-radius: 50%
  background-color: white
  margin-right: 5px

  .icon
    width: 15px
</style>
